export const experiences = [
    {
        title: 'Java Developer (Developer V)',
        company: 'FNB South Africa',
        type: 'Full-time',
        period: 'Jan 2026 – Present',
        location: 'South Africa · Hybrid',
        bullets: [
            'Leads technical decision-making for assigned services/modules (design trade-offs, delivery approach, production readiness).',
            'Drives code quality standards through reviews (maintainability, security, performance, test depth).',
            'Leads/coordinates complex production issue resolution and prevention work (root cause + follow-up improvements).',
            'Mentors developers and improves team execution through patterns, documentation, and knowledge sharing.',
        ],
        tags: ['Spring Boot', 'Microservices', 'Technical Leadership', 'Mentoring'],
        color: '#194e8f',
    },
    {
        title: 'Java Developer (Developer IV)',
        company: 'FNB South Africa',
        type: 'Full-time',
        period: 'Nov 2024 – Dec 2025',
        location: 'South Africa · Hybrid',
        bullets: [
            'Provided technical input on solution design for medium-to-large enhancements, aligning to agreed programming standards and patterns.',
            'Produced technical/logical specifications from functional requirements and translated them into clean, maintainable Java code.',
            'Built and enhanced REST APIs and integration services, focusing on contract consistency, validation, and error handling.',
            'Owned complex defect investigations: reproduced issues, debugged root cause, implemented fixes, and improved performance.',
            'Implemented/monitored security and policy controls within applications (secure coding practices, access control alignment).',
            'Supported modernisation work (Java EE → Spring Boot) and refactoring for scalability and maintainability.',
            'Strengthened delivery quality via CI/CD participation, code reviews, and unit/integration test practices.',
        ],
        tags: ['Java', 'Spring Boot', 'REST APIs', 'CI/CD', 'Security'],
        color: '#194e8f',
    },
    {
        title: 'Java Developer (Developer III)',
        company: 'FNB South Africa',
        type: 'Full-time',
        period: 'Feb 2022 – Oct 2024',
        location: 'South Africa · Hybrid',
        bullets: [
            'Developed and maintained Spring Boot microservices and web applications; contributed across the SDLC (design, build, test, release).',
            'Contributed to platform scalability improvements and migration/upgrade initiatives (Java EE → Spring Boot).',
            'Supported production investigations and delivered fixes to prevent repeat incidents.',
            'Participated in CI/CD, PR reviews, and testing practices to improve release confidence.',
        ],
        tags: ['Java', 'Spring Boot', 'Microservices', 'CI/CD'],
        color: '#194e8f',
    },
    {
        title: 'Java Developer (Developer II)',
        company: 'FNB South Africa',
        type: 'Full-time',
        period: 'Sep 2020 – Jan 2022',
        location: 'South Africa · Hybrid',
        bullets: [
            'Collaborated with developers on designing, testing (TDD), implementing, and maintaining Java programs.',
            'Developed microservices and web applications across every phase of the development cycle.',
            'Enhanced FNB nav App look and feel using OCEP (House framework).',
            'Contributed to system and software architectural development.',
            'Collaborated on production incident investigations and solutions.',
            'Upgraded codebase for scalability and latest technologies (Java EE → Spring Boot).',
            'CI/CD pipeline integration, pull requests, code reviews, load/stress testing, unit/integration testing.',
        ],
        tags: ['Java', 'Spring Boot', 'Angular', 'Docker', 'SQL', 'Gradle'],
        color: '#194e8f',
    },
    {
        title: 'Java Developer (Developer I)',
        company: 'FNB South Africa',
        type: 'Contract',
        period: 'Feb 2020 – Aug 2020',
        location: 'Johannesburg · Remote',
        bullets: [
            'Implemented and maintained in-house application.',
            'Designed and developed scalable API for managing third-party products.',
            'Automated and optimized business logic for the core products.',
        ],
        tags: ['Java', 'SQL', 'Docker', 'REST APIs'],
        color: '#2eafec',
    },
    {
        title: 'Java Developer – Intern',
        company: 'FNB South Africa (Forex)',
        type: 'Internship',
        period: 'Feb 2019 – May 2019',
        location: 'Johannesburg Metropolitan Area',
        bullets: [
            'Designed and developed an in-house application using Java, Angular, and MSSQL.',
            'Integrated multiple third-party systems.',
        ],
        tags: ['Java', 'Angular', 'MSSQL', 'SQL', 'Git'],
        color: '#ba55d3',
    },
    {
        title: 'Business Administration Intern',
        company: 'DAV Professional Placement Group',
        type: 'Internship',
        period: 'Mar 2016 – Feb 2017',
        location: 'Bryanston',
        bullets: [
            'Finance Department – Assisted with general filing, invoicing, generating reports, creating POs and PRs.',
            'Facilities & Maintenance – Building maintenance, boardroom setup, access card activation, printer installation, stock take.',
            'Office Coordinator – Coordinating company meetings, creating PowerPoint presentations, recording meetings and events.',
        ],
        tags: ['Communication', 'Administration', 'MS Office'],
        color: '#6c757d',
    },
];
